import { RecommenderSettings, WeekHeuristicsWeights } from '@/api/types'
import React from 'react'
import { HeuristicSlider } from './HeuristicSlider'
import { Label } from '@/components/Label'
import { Switch } from '@/components/Switch'

type Props = {
  recommenderSettings: RecommenderSettings
  setRecommenderSettings: (settings: RecommenderSettings) => void
  setWeekImprovement: (value: boolean) => void
} & React.HTMLAttributes<HTMLDivElement>

export function WeekHeuristics({
  recommenderSettings,
  setRecommenderSettings,
  setWeekImprovement,
  ...props
}: Props) {
  function setHeuristicWeight(key: keyof WeekHeuristicsWeights, value: number) {
    setRecommenderSettings({
      ...recommenderSettings,
      weekHeuristicsWeights: {
        ...recommenderSettings.weekHeuristicsWeights,
        [key]: value,
      },
    })
  }

  return (
    <div {...props}>
      <Switch
        isSelected={recommenderSettings.runWeekImprovement}
        onChange={setWeekImprovement}
        style={{ marginBottom: '10px' }}>
        Run week improvement
      </Switch>
      <Label>Week heuristics</Label>

      <HeuristicSlider
        label="NL_FISH"
        value={recommenderSettings.weekHeuristicsWeights.NL_FISH}
        onChange={(value) => {
          setHeuristicWeight('NL_FISH', value)
        }}
        isDisabled={!recommenderSettings.runWeekImprovement}
      />
      <HeuristicSlider
        label="INCLUDE_WHITE_MEAT"
        value={recommenderSettings.weekHeuristicsWeights.INCLUDE_WHITE_MEAT}
        onChange={(value) => {
          setHeuristicWeight('INCLUDE_WHITE_MEAT', value)
        }}
        isDisabled={!recommenderSettings.runWeekImprovement}
      />
    </div>
  )
}
